import { useQuery } from '@tanstack/react-query';
import { useStudentAuth } from '@/frontend/contexts/StudentAuthContext';
import { getMyRegulationStatus } from '@/backend/services/studentRegulations';
import { MyRegulationStatus } from '@/shared/types';

/**
 * Hook to fetch the current regulation and acceptance status for logged-in student.
 * staleTime inherits the global 0 so every mount and every invalidation
 * triggers a fresh fetch from Firestore.
 */
export function useMyRegulationStatus() {
  const { user } = useStudentAuth();

  return useQuery<MyRegulationStatus | null>({
    queryKey: ['my-regulation-status', user?.uid],
    queryFn: async () => {
      if (!user?.uid) return null;
      return getMyRegulationStatus(user.uid);
    },
    enabled: !!user?.uid,
  });
}
